<template>
  <div class="f-fl center_left">
    <div class="center_nav">
      <dl>
        <dt
          class="index"
          :class="{ cur: activeIndex == 0 }"
          style="cursor: pointer"
          @click="goPersonalCenterHome"
        >
          <img
            src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-info.png"
            class="no-select"
          />
          <img
            src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-info-select.png"
            class="select"
          />
          <span style="margin-left: 5px">个人中心</span>
        </dt>
        <dd class="localReward" v-if="!isOverseaUser">
          <a :href="rewardLink">
            <img
              src="https://resource.rcclchina.com.cn/reward/side_bar_tb_home.png"
              class="no-select"
            />
            <img
              src="https://resource.rcclchina.com.cn/reward/side_bar_tb_home_active.png"
              class="select"
            />
            <span>皇家游享荟</span>
          </a>
        </dd>
        <dd class="myOrder" :class="{ cur: activeIndex == 1 }">
          <router-link to="/Rccl.UserCenter/OrderRecord/List">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-order.png"
              class="no-select"
            />
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-order-select.png"
              class="select"
            />
            <span>我的订单</span>
            <template v-if="isRow == 1"><i class="orderRecord-tab-badge" v-if="bookingsCount > 0">{{
              bookingsCount
            }}</i></template>
             <template v-else><i class="orderRecord-tab-badge" v-if="rowBookingsCount > 0">{{
              rowBookingsCount
            }}</i></template>
          </router-link>
        </dd>
        <dd class="" :class="{ cur: activeIndex == 2 }">
          <router-link to="/Rccl.UserCenter/UserCoupon/UserCoupon">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-coupon.png"
              class="no-select"
            />
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-coupon-select.png"
              class="select"
            />
            <span>优惠券</span>
            <i class="canUseCount" v-if="couponsCount > 0">{{
              couponsCount
            }}</i>
          </router-link>
        </dd>

        <dd class="wishList" :class="{ cur: activeIndex == 3 }">
          <router-link to="/Rccl.UserCenter/WishList/List">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-wishlist.png"
              class="no-select"
            />
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-wishlist-select.png"
              class="select"
            />
            <span>收藏夹</span>
            <i class="wishlistCount" v-if="wishListCount > 0">{{
              wishListCount
            }}</i>
          </router-link>
        </dd>

        <dd class="contact" :class="{ cur: activeIndex == 7 }">
          <router-link to="/Rccl.UserCenter/UserContact/List">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-contact.png"
              class="no-select"
            />
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-contact-select.png"
              class="select"
            />
            <span>常用联系人</span>
          </router-link>
        </dd>
        <dd class="contact" :class="{ cur: activeIndex == 8 }">
          <router-link to="/Rccl.UserCenter/CustomerInfo/EditInfo?enterType=menu">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/gerxx.png"
              class="no-select"
            />
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-editInfo-select.png"
              class="select"
            />
            <span>个人信息</span>
          </router-link>
        </dd>
        <dd class="contact">
          <router-link to="/Rccl.Review/Travel/tn-n-n-0-0-9.html">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-review.png"
              class="no-select"
            />
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-review-select.png"
              class="select"
            />
            <span>游记美图</span>
          </router-link>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "PersonalCenterMenu",
  props: {
    activeIndex: {
      type: Number,
    },
  },
  beforeMount() {
    this.initPage();
  },
  methods: {
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      if (userToken && userToken.length > 0) {
        const { success, data } = await api.user.GetUserRelevanceInfoHP(
          userToken
        );
        if (success && data) {
          let personalCenterData = {
            bookingsCount: 0,
            couponsCount: 0,
            wishListCount: 0,
            tuiBookingsCount: 0,
            rowBookingsCount:0
          };
          if (!isNaN(data.bookingsCount)) {
            personalCenterData.bookingsCount = data.bookingsCount;
          }
           if (!isNaN(data.tuiBookingsCount)) {
            personalCenterData.tuiBookingsCount = data.tuiBookingsCount;
          }
          if (!isNaN(data.couponsCount)) {
            personalCenterData.couponsCount = data.couponsCount;
          }
          if (!isNaN(data.wishListCount)) {
            personalCenterData.wishListCount = data.wishListCount;
          }
          if (!isNaN(data.rowBookingsCount)) {
            personalCenterData.rowBookingsCount = data.rowBookingsCount;
          }
          this.$store.commit(
            "SET_PERSONAL_CENTER_ITEM_COUNT",
            personalCenterData
          );
        }
      }
    },
    goPersonalCenterHome() {
      this.$router.push("/Rccl.UserCenter/CustomerInfo/Info?IsHomePage=true");
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
		isOverseaUser () {
			if (!this.userInfo || !this.userInfo.callingCode) {
				return false;
			}
      return this.userInfo != null && this.userInfo.callingCode != "86" && this.userInfo.callingCode != '+86';
    },
    bookingsCount() {
      return this.$store.state.user.bookingsCount;
    },
    tuiBookingsCount() {
      return this.$store.state.user.tuiBookingsCount;
    },
    rowBookingsCount() {
      return this.$store.state.user.rowBookingsCount;
    },
    isRow() {
      return this.$store.state.user.isRow;
    },
    wishListCount() {
      return this.$store.state.user.wishListCount;
    },
    couponsCount() {
      return this.$store.state.user.couponsCount;
    },
    rewardLink() {
      if (this.userInfo && this.userInfo.userIdentity == 1) {
        return `${process.env.VUE_APP_REWARD_URL}/rewardpc?token=${this.userInfo.localRewardToken}`;
      } else {
        return "/Rccl.UserCenter/CustomerInfo/SignupReward";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.center_left {
  position: relative;
  top: 20px;
  width: 230px;
  height: 971px;
  background: url(https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-menu.jpg)
    no-repeat center;
}
.center_nav {
  dt {
    font-size: 20px;
    color: #fff;
    padding: 20px 38px;
    font-weight: bold;
    img.no-select {
      display: inline;
    }
    img.select {
      display: none;
    }
  }
  dd {
    a {
      position: relative;
      display: block;
      line-height: 44px;
      padding: 0 42px;
      color: #fff;
      text-decoration: unset;
      text-shadow: #006ab9 1px 1px 1px;
      font-size: 14px;
      font-weight: 400;
      img {
        width: 20px;
      }
      img.no-select {
        display: inline;
      }
      img.select {
        display: none;
      }
      span {
        margin-left: 8px;
        vertical-align: middle;
      }
      i {
        color: #fff;
        background-color: #ff3022;
        border-radius: 50%;
        margin-left: 4px;
        display: inline;
        font-weight: 300 !important;
        position: absolute;
        width: 15px;
        height: 15px;
        top: 15px;
        line-height: 16px;
        font-size: 12px;
        text-align: center;
        text-shadow: none;
      }
    }
  }

  .cur,
  a:hover {
    img.no-select {
      display: none !important;
    }
    img.select {
      display: inline !important;
    }
  }

  dd a:hover,
  dd.cur a {
    background-color: #0b5993;
    color: #edbb16;
    font-weight: 600;
  }
  dt.cur span {
    color: #edbb16;
  }
}
</style>
